module.exports = __webpack_public_path__ + "static/media/appstore.b823fe19.JPG";